/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookies_Analytics_DescriptionInputs */

const en_cookies_analytics_description = /** @type {(inputs: Cookies_Analytics_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage stats that show us what's slow, broken, or ignored. If you agree and sign in, your visits are tied to your account. If you don't, we still count page views, without cookies or identifiers. Turning this off also clears any analytics cookies already set.`)
};

const pl_cookies_analytics_description = /** @type {(inputs: Cookies_Analytics_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statystyki użycia, które pokazują nam, co jest wolne, zepsute albo pomijane. Jeśli się zgodzisz i zalogujesz, Twoje wizyty zostaną powiązane z kontem. Jeśli nie, nadal liczymy odsłony, ale bez plików cookie i identyfikatorów. Wyłączenie tego czyści też ustawione już pliki analityczne.`)
};

/**
* | output |
* | --- |
* | "Usage stats that show us what's slow, broken, or ignored. If you agree and sign in, your visits are tied to your account. If you don't, we still count page v..." |
*
* @param {Cookies_Analytics_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const cookies_analytics_description = /** @type {((inputs?: Cookies_Analytics_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookies_Analytics_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_cookies_analytics_description(inputs)
	return en_cookies_analytics_description(inputs)
});